import { render, staticRenderFns } from "./configcombo.vue?vue&type=template&id=f7cadd90"
import script from "./configcombo.vue?vue&type=script&lang=js"
export * from "./configcombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports